import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}policies/`;

export default {
  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },

  get(id) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders() });
  },

  create(data) {
    // FormData for file upload
    return axios.post(API_URL, data, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },

  update(id, data) {
    const isFD = typeof FormData !== "undefined" && data instanceof FormData;

    if (isFD) {
      if (!data.has("_method")) data.append("_method", "PUT");
      return axios.post(`${API_URL}${id}`, data, {
        headers: buildHeaders({}, { multipart: true }),
      });
    }

    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },

  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },

  bulkDelete(ids) {
    return axios.post(
      `${API_URL}bulk-delete`,
      { ids },
      { headers: buildHeaders() }
    );
  },

  exportReport(format, params = {}) {
    return axios.get(`${API_URL}report/export`, {
      params: { ...params, format },
      responseType: "blob",
      headers: buildHeaders(),
    });
  },
};
